import { IconChevronRight } from '@heathmont/moon-assets';
import Link from '@/client/components/Link';
import Translation from '@/client/components/Translation';
import Button from '@/external/components/Button';
import { TournamentFragment } from '@/shared/graphql/TournamentFragment.generated';

type Props = {
  tournament?: TournamentFragment;
  translations: Record<string, string>;
};

const ActionButton: FC<Props> = ({ tournament, translations }) => (
  <div
    data-testid="read-more"
    className=" grid grid-cols-[min-content] place-items-center justify-end gap-4"
  >
    <Link href={`/tournaments/${tournament?.shortUrl}`}>
      <>
        <div className="grid h-[5.375rem] w-4 items-center justify-end gap-4 2xl:hidden">
          <IconChevronRight color="bulma.100" />
        </div>
        <span className="hidden whitespace-nowrap 2xl:block">
          <Button variant="secondary">
            <Translation id="general.read_more" translations={translations} />
          </Button>
        </span>
      </>
    </Link>
  </div>
);

export default ActionButton;
